module.exports = __webpack_public_path__ + "static/media/focus-bg.0e973879.webp";